<template>
    <v-snackbar v-model="snackbar" :color="color" :timeout="timeout" bottom>
        {{ message }}
        <template v-slot:action="{ attrs }">
            <v-btn text v-bind="attrs" @click="onClose()">
                {{ $t('button.close') }}
            </v-btn>
        </template>
    </v-snackbar>
</template>

<script>
    import SnackbarMixin from "@/mixins/SnackbarMixin";

    export default {
        name: 'SnackbarComponent',
        mixins: [SnackbarMixin],
        data: () => ({
            snackbar: false,
            message: null,
            color: null
        }),
        computed: {
            timeout() {
                return 6000;
            }
        },
        methods: {
            onClose() {
                this.snackbar = false;
                this.$store.commit('snackbar/resetSnackbar');
            },
            showSnackbar(message, color) {
                this.snackbar = true;
                this.message = message;
                this.color = color;
                setTimeout(() => {
                    this.$store.commit('snackbar/resetSnackbar');
                }, this.timeout);
            }
        },
        created() {
            // get stored snackbars (from previous route for example ...)
            if (this.$store.getters['snackbar/isVisible'] === true) {
                this.showSnackbar(this.$store.getters['snackbar/getMessage'], this.$store.getters['snackbar/getColor']);
            }

            // listen to store snackbar/showSnackbar attribute
            let self = this;
            this.$store.watch(() => this.$store.getters['snackbar/isVisible'], (isVisible) => {
                if (isVisible === true) {
                    self.showSnackbar(this.$store.getters['snackbar/getMessage'], this.$store.getters['snackbar/getColor']);
                }
            });
        }
    }
</script>
